import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "redux/global";
import mapReducer from "redux/map";

const store = configureStore({
  reducer: { global: globalReducer, map: mapReducer },
});
export default store;
export type TStore = ReturnType<typeof store.getState>;
